import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-login-client-layout',
  templateUrl: './login-client-layout.component.html',
  styleUrls: ['./login-client-layout.component.scss']
})
export class LoginClientLayoutComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
